// Spain
export const locale = {
	lang: 'es',
	data: {
		TRANSLATOR: {
			SELECT: 'Elige tu idioma',
		},
		MENU: {
			NEW: 'nuevo',
			ACTIONS: 'Comportamiento',
			CREATE_POST: 'Crear nueva publicación',
			REPORTS: 'Informes',
			APPS: 'Aplicaciones',
			DASHBOARD: 'Tablero'
		},
		AUTH: {
			GENERAL: {
				OR: 'O',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'No tienes una cuenta?',
				SIGNUP_BUTTON: 'Regístrate',
				FORGOT_BUTTON: 'Se te olvidó tu contraseña',
				BACK_BUTTON: 'Espalda',
				PRIVACY: 'Intimidad',
				LEGAL: 'Legal',
				CONTACT: 'Contacto',
			},
			LOGIN: {
				TITLE: 'Crear una cuenta',
				BUTTON: 'Iniciar Sesión',
			},
			FORGOT: {
				TITLE: 'Contraseña olvidada?',
				DESC: 'Ingrese su correo electrónico para restablecer su contraseña',
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered. Please use your registered account to login.'
			},
			INPUT: {
				EMAIL: 'Email',
				USER: 'Usuario',
				FULLNAME: 'Fullname',
				PASSWORD: 'Contraseña',
				CONFIRM_PASSWORD: 'Confirm Password',
			},
			VALIDATION: {
				INVALID: '{{name}} no es valido.',
				REQUIRED: '{{name}} es obligatorio.',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'El usuario o clave incorrecta.'
			}
		},
		LEGALATTENTION: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			
            REQUESTS: {
                DELETE_REQUEST_SIMPLE: {
					TITLE: 'Eliminar Solicitud',
					DESCRIPTION: '¿Estás seguro de eliminar permanentemente esta Solicitud?',
					WAIT_DESCRIPTION: 'Eliminando solicitud...',
					MESSAGE: 'Solicitud ha sido eliminada'
				},
			},
			
			REQUESTSATTENTION: {
                CONFIRM_ATTENTION_REQUEST: {
					TITLE: 'Confirmar Programación de Atención',
					DESCRIPTION: '¿Estás seguro de iniciar la atención de esta Solicitud?',
					WAIT_DESCRIPTION: 'Iniciando Programación de solicitud...',
					MESSAGE: 'La Solicitud ha sido programada.'
				},
				END_ATTENTION_REQUEST: {
					TITLE: 'Finalizar Atención',
					DESCRIPTION: '¿Estás seguro de finalizar la atención de esta Solicitud?',
					WAIT_DESCRIPTION: 'Finalizando atención de solicitud...',
					MESSAGE: 'La Solicitud ha sido atendida.'
				},
				SAVE_ATTENTION_REQUEST: {
					TITLE: 'Guardar Atención',
					DESCRIPTION: 'Guardarás los cambios sin Finalizar la atención',
					WAIT_DESCRIPTION: 'Guardando atención de solicitud...',
					MESSAGE: 'Proceso de Atención ha sido guardada.'
				},
				RESCHEDULE_ATTENTION_REQUEST: {
					TITLE: 'Confirmar Reprogramación de Atención',
					DESCRIPTION: '¿Estás seguro de reprogramar la atención de esta Solicitud?',
					WAIT_DESCRIPTION: 'Solicitando Reprogramación de atención...',
					MESSAGE: 'La Atención ha sido reprogramada.'
				}
            },
			
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		}
	}
};
